import React, {useState} from 'react';
import {connect} from 'react-redux';
import {startActivateService, startRegisterService, startResendCodeService} from '../actions/auth';

const Signup = (props) => {

    const registerSteps = {enterInfo: "enterInfo", verification: "verification"}
    const signupStates = {
        idle: "idle",
        loading: "loading",
        success: "success",
        failure: "failure"
    }

    const [currentStep, setCurrentStep] = useState(registerSteps.enterInfo)
    const [phone, setPhone] = useState("")
    const [password, setPassword] = useState("")
    const [passRepeat, setPassRepeat] = useState("")
    const [verificationCode, setVerificationCode] = useState("")
    const [signupStatus, setSignupStatus] = useState(signupStates.idle)
    const [phoneError, setPhoneError] = useState(false)
    const [passwordError, setPasswordError] = useState(false)
    const [passRepeatError, setPassRepeatError] = useState(false)
    const [codeError, setCodeError] = useState(false)

    const onLoginClicked = () => {
        props.history.push('/login')
    }

    const stepRenderer = () => {
        switch (currentStep){
            case registerSteps.enterInfo:
                return renderDataInput()
            case registerSteps.verification:
                return renderVerification()
        }
    }

    const onPhoneChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/))
            setPhone(e.target.value)
    }

    const onPassChanged = (e) => {
        setPassword(e.target.value)
    }

    const onPassRepeatChanged = (e) => {
        setPassRepeat(e.target.value)
    }

    const onVerificationCodeChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/))
            setVerificationCode(e.target.value)
    }

    const onSendCode = () => {
        let hasError = false;
        if (phone === "" || !phone.match(/^09[0-9]{9}$/)){
            setPhoneError(true);
            hasError = true
        }
        else{
            setPhoneError(false);
        }
        if (password === "" || password !== passRepeat){
            setPasswordError(true);
            hasError = true
        }
        else{
            setPasswordError(false);
        }
        if (passRepeat === "" || password !== passRepeat){
            setPassRepeatError(true);
            hasError = true
        }
        else{
            setPassRepeatError(false);
        }
        if (!hasError) {
            setSignupStatus(signupStates.loading)
            props.startRegisterService(password, phone)
            .then(({
                success,
                error
            }) => {
                if (success) {
                    setSignupStatus(signupStates.idle)
                    setCurrentStep(registerSteps.verification)
                } else {
                    setSignupStatus(signupStates.failure)
                }
            })
        }
    }

    const onEditClicked = () => {
        if (signupStatus !== signupStates.loading){
            setSignupStatus(signupStates.idle)
            setCurrentStep(registerSteps.enterInfo)
        }
    }

    const onResendCodeClicked = () => {
        setSignupStatus(signupStates.loading)
        props.startResendCodeService(phone)
        .then(({
            success,
            error
        }) => {
            if (success) {
                setSignupStatus(signupStates.idle)
            } else {
                setSignupStatus(signupStates.failure)
            }
        })
    }

    const onFinalizeClicked = () => {
        if (verificationCode === ""){
            setCodeError(true)
        }
        else {
            setCodeError(false)
            setSignupStatus(signupStates.loading)
            props.startActivateService(verificationCode, phone)
            .then(({
                success,
                error
            }) => {
                if (success) {
                    // setSignupStatus(signupStates.idle)
                    props.history.push("/login")
                } else {
                    setSignupStatus(signupStates.failure)
                }
            })
        }

    }


    const renderDataInput = () => {

        return (
            <>
                <input className={`${phoneError ? "about__input--error" : "about__input"} p-3 mb-3 mt-4`} type="text" value={phone} onChange={onPhoneChanged} placeholder="شماره همراه" />
                <input className={`${passwordError ? "about__input--error" : "about__input"} p-3 mb-4`} type="password" value={password} onChange={onPassChanged} placeholder="رمز عبور" />
                <input className={`${passRepeatError ? "about__input--error" : "about__input"} p-3 mb-4`} type="password" value={passRepeat} onChange={onPassRepeatChanged} placeholder="تکرار رمز عبور" />
                <button className="about__btn py-4" disabled={signupStatus === signupStates.loading} onClick={onSendCode}>ارسال کد</button>
                {
                    signupStatus === signupStates.failure ? (
                        <span className="error-dialog mt-3 py-1">خطا در ایجاد حساب کاربری</span>
                    ) : (undefined)
                }
            </>
        )
    }

    const renderVerification = () => {

        return(
            <>
                <input className={`${phoneError ? "about__input--error" : "about__input"} p-3 mb-3 mt-4`} disabled value={phone} onChange={onPhoneChanged} type="text" placeholder="شماره همراه" />
                <input className={`${codeError ? "about__input--error" : "about__input"} p-3 mb-4`} type="text" value={verificationCode} onChange={onVerificationCodeChanged} placeholder="کد تایید" />
                <div className="optimized__d-flex-class justify-content-start mb-4">
                    <span className="about__link-text" onClick={onEditClicked}>اصلاح اطلاعات</span>
                </div>
                <button className="about__btn py-4" disabled={signupStatus === signupStates.loading} onClick={onResendCodeClicked}>ارسال مجدد کد</button>
                <button className="about__btn py-4 mt-3" disabled={signupStatus === signupStates.loading} onClick={onFinalizeClicked}>ثبت نهایی</button>
                {
                    signupStatus === signupStates.failure ? (
                        <span className="error-dialog mt-3 py-1">خطا در فعالسازی حساب کاربری</span>
                    ) : (undefined)
                }
            </>
        )
    }

    return (
        <div className="container-sm optimized__d-flex-class flex-column h-100 pt-0 px-0 pb-4 justify-content-start about">
            <div className="optimized__d-flex-class">
                <button className="btn__tab flex-grow-1" onClick={onLoginClicked}>ورود</button>
                <button className="btn__tab--active flex-grow-1">ثبت نام</button>
            </div>
            <div className="optimized__d-flex-class flex-column mx-4 mt-3 px-4 pb-4 about__description">
                {stepRenderer()}
            </div>
        </div>
    );
}

const mapDispatchToProps = (dispatch) => ({
    startRegisterService: (password, phoneNo) => dispatch(startRegisterService({password, phoneNo})),
    startActivateService: (activationKey, phoneNo) => dispatch(startActivateService({activationKey, phoneNo})),
    startResendCodeService: (phoneNo, isRegister="") => dispatch(startResendCodeService({phoneNo, isRegister}))
})

export default connect(undefined, mapDispatchToProps)(Signup);